module.exports = __webpack_public_path__ + "static/media/download-captions.387ed0a0.svg";